import { urlProductList } from '@/urls';
import { LoaderFunctionArgs, useLoaderData, useNavigate } from 'react-router';
import { productApi } from '@repo/api-client';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@repo/ui/components/dialog';
import { CreateProductForm } from '@/components/product/create-product-form';

function CreateProduct() {
  const navigate = useNavigate();
  const { categories, clubId } = useLoaderData<typeof route.loader>();

  const handleClose = () => {
    navigate(urlProductList(clubId), { viewTransition: true });
  };

  return (
    <Dialog open={true} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent>
        <DialogTitle>Crear Producto</DialogTitle>
        <DialogDescription>Completa los campos para crear un nuevo producto.</DialogDescription>
        <CreateProductForm categories={categories.results} />
      </DialogContent>
    </Dialog>
  );
}

export const route = {
  path: 'nuevo',
  element: <CreateProduct />,
  loader: async ({ params }: LoaderFunctionArgs) => {
    const clubId = params.id as string;
    const categories = await productApi.getCategories(clubId);
    return { categories, clubId };
  },
};
